import { cn } from "@/shared/lib/utils";

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: "default" | "success" | "warning" | "error" | "info";
  children: React.ReactNode;
}

export function Badge({ className, variant = "default", children, ...props }: BadgeProps) {
  const variants = {
    default: "bg-gray-100 text-gray-700",
    success: "bg-success-100 text-success-700",
    warning: "bg-warning-100 text-warning-700",
    error: "bg-error-100 text-error-700",
    info: "bg-primary-100 text-primary-700",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium",
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}

// Helper function to get variant based on status
export function getStatusVariant(status: string): BadgeProps["variant"] {
  const statusMap: Record<string, BadgeProps["variant"]> = {
    new: "success",
    active: "info",
    pending: "default",
    reserved: "warning",
    completed: "success",
    expired: "error",
    suspended: "error",
    sent: "info",
    accepted: "success",
    rejected: "error",
    draft: "default",
  };

  return statusMap[status] || "default";
}
